export const ACCOUNT_SECTION_ALIASES = Object.freeze({
  profile: "profile",
  household: "household",
  cooking: "household",
  nutrition: "nutrition",
  dietary: "nutrition",
  "meal-review": "nutrition",
  shopping: "shopping",
  "shopping-lists": "shopping",
  inventory: "inventory",
  stock: "inventory",
  deliveries: "deliveries",
  "training-plan": "training-plan",
  training: "training-plan",
  delivery: "deliveries",
  documents: "documents",
  billing: "documents",
  invoice: "documents",
  addresses: "addresses",
  address: "addresses",
  performance: "performance",
  history: "performance",
  notifications: "notifications",
  push: "notifications",
  appearance: "appearance",
  language: "appearance",
  security: "security",
});

export function accountSectionFromParams(params) {
  const key = params.get("section") || "";
  return Object.prototype.hasOwnProperty.call(ACCOUNT_SECTION_ALIASES, key) ? ACCOUNT_SECTION_ALIASES[key] : null;
}

// Existing notification URLs now open a full detail view, not an accordion.
export function accountSectionHref(section, context = {}) {
  const params = new URLSearchParams({ tab: "account" });
  const canonical = accountSectionFromParams(new URLSearchParams({ section: section || "" }));
  if (canonical) {
    params.set("section", canonical);
    const allowed = {
      nutrition: ["week_start", "review", "version"], shopping: ["week_start"],
      deliveries: ["order"], documents: ["invoice"],
    }[canonical] || [];
    allowed.forEach((key) => {
      if (context[key]) params.set(key, String(context[key]));
    });
  }
  return `/today?${params}`;
}
